import { render } from "./SelectedEmployee.vue?vue&type=template&id=27663eb7&scoped=true"
import script from "./SelectedEmployee.vue?vue&type=script&lang=js"
export * from "./SelectedEmployee.vue?vue&type=script&lang=js"

import "./SelectedEmployee.vue?vue&type=style&index=0&id=27663eb7&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27663eb7"]])

export default __exports__